const mutations = {
	setDefaults: (state, payload) => {
		state.defaults = payload;
	},
	setSkills: (state, payload) => {
		state.skills = payload;
	},
	setCategories: (state, payload) => {
		state.categories = payload;
	},
	setPortfolio: (state, payload) => {
		state.portfolio = payload;
	},
	setExp: (state, payload) => {
		state.exp = payload;
	}
};

export default mutations;
